export default __webpack_public_path__ + "img/phone.59fb5a35.svg";